import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sb-empty"
}
const _hoisted_2 = {
  key: 1,
  class: "sb-empty"
}
const _hoisted_3 = {
  key: 0,
  class: "sb-teams",
  role: "tablist"
}
const _hoisted_4 = ["aria-selected"]
const _hoisted_5 = { class: "sb-team-name" }
const _hoisted_6 = { class: "sb-team-meta" }
const _hoisted_7 = { class: "bad" }
const _hoisted_8 = { class: "warn" }
const _hoisted_9 = ["aria-selected", "onClick"]
const _hoisted_10 = { class: "sb-team-name" }
const _hoisted_11 = { class: "sb-team-meta" }
const _hoisted_12 = { class: "bad" }
const _hoisted_13 = { class: "warn" }
const _hoisted_14 = { class: "sb-bar" }
const _hoisted_15 = { class: "sb-seg" }
const _hoisted_16 = {
  key: 0,
  class: "sb-search"
}
const _hoisted_17 = {
  key: 0,
  class: "sb-search-count"
}
const _hoisted_18 = { class: "sb-week" }
const _hoisted_19 = { class: "sb-week-l" }
const _hoisted_20 = { class: "sb-week-k" }
const _hoisted_21 = { class: "sb-week-nav" }
const _hoisted_22 = { class: "sb-week-v" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "sb-stat" }
const _hoisted_25 = { class: "sb-week-msg" }
const _hoisted_26 = {
  key: 1,
  class: "sb-empty sb-empty-team"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  key: 2,
  class: "sb-cards"
}
const _hoisted_29 = {
  key: 0,
  class: "sb-group-h"
}
const _hoisted_30 = { class: "sb-card-top" }
const _hoisted_31 = { class: "sb-card-ic" }
const _hoisted_32 = { class: "sb-card-nm" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "sb-card-own" }
const _hoisted_35 = {
  key: 0,
  class: "sb-streak"
}
const _hoisted_36 = { class: "sb-stats" }
const _hoisted_37 = {
  key: 1,
  class: "sb-def"
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "sb-prog-wrap" }
const _hoisted_40 = { class: "sb-card-acts" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "sb-grid-wrap" }
const _hoisted_45 = { class: "sb-grid" }
const _hoisted_46 = ["title"]
const _hoisted_47 = {
  key: 0,
  class: "sb-group-row"
}
const _hoisted_48 = ["colspan"]
const _hoisted_49 = { class: "sb-group-h" }
const _hoisted_50 = { class: "sb-o" }
const _hoisted_51 = ["title"]
const _hoisted_52 = { class: "sb-m" }
const _hoisted_53 = ["title", "onClick"]
const _hoisted_54 = ["title"]
const _hoisted_55 = { class: "sb-g" }
const _hoisted_56 = { class: "sb-goal" }
const _hoisted_57 = {
  key: 0,
  class: "sb-c editing"
}
const _hoisted_58 = ["aria-label"]
const _hoisted_59 = ["title", "onClick"]
const _hoisted_60 = {
  key: 1,
  class: "sb-enter"
}
const _hoisted_61 = { class: "sb-avg" }
const _hoisted_62 = {
  key: 10,
  class: "error-msg-wrap"
}
const _hoisted_63 = {
  class: "form-wrapper slide-up",
  style: {"width":"420px"}
}
const _hoisted_64 = { class: "form-close" }
const _hoisted_65 = { class: "sb-modal-title" }
const _hoisted_66 = { class: "sb-due-row" }
const _hoisted_67 = ["value"]
const _hoisted_68 = {
  class: "sb-intro",
  style: {"margin-top":"6px"}
}
const _hoisted_69 = { class: "sb-modal-acts" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_scoreboard_metric_modal = _resolveComponent("scoreboard-metric-modal")!
  const _component_scoreboard_entry_modal = _resolveComponent("scoreboard-entry-modal")!
  const _component_scoreboard_nudge_modal = _resolveComponent("scoreboard-nudge-modal")!
  const _component_forge_team = _resolveComponent("forge-team")!
  const _component_scoreboard_who_can_view = _resolveComponent("scoreboard-who-can-view")!
  const _component_scoreboard_trend_modal = _resolveComponent("scoreboard-trend-modal")!
  const _component_quick_add_agenda_item = _resolveComponent("quick-add-agenda-item")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loaded && _ctx.team && !_ctx.activeTeam)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_svg_icon, { icon: "chart" }),
          _createElementVNode("div", null, [
            _createTextVNode(" You can't open the " + _toDisplayString(_ctx.teamLabel(_ctx.team)) + " scorecard. ", 1),
            _cache[37] || (_cache[37] = _createElementVNode("span", { class: "sb-muted" }, "Only people on the team and Team Hub admins can.", -1))
          ])
        ]))
      : (_ctx.loaded && !_ctx.teams.length && !_ctx.myMetrics.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_svg_icon, { icon: "chart" }),
            _cache[38] || (_cache[38] = _createElementVNode("div", null, [
              _createTextVNode(" You don't belong to a team yet. "),
              _createElementVNode("span", { class: "sb-muted" }, "Contact your administrator to be added to a team.")
            ], -1))
          ]))
        : (_ctx.loaded && _ctx.activeTeam)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (!_ctx.team)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (_ctx.myEmployeeID)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          role: "tab",
                          "aria-selected": !_ctx.searching && !!_ctx.activeTeam.Mine,
                          class: _normalizeClass(["sb-team", !_ctx.searching && _ctx.activeTeam.Mine ? 'on' : '']),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectMine()))
                        }, [
                          _createElementVNode("span", _hoisted_5, [
                            _createVNode(_component_svg_icon, {
                              icon: "user",
                              class: "sb-team-ic"
                            }),
                            _cache[39] || (_cache[39] = _createTextVNode("My numbers", -1))
                          ]),
                          _createElementVNode("span", _hoisted_6, [
                            _createTextVNode(_toDisplayString(_ctx.myMetrics.length) + " across " + _toDisplayString(_ctx.myTeamCount) + " team" + _toDisplayString(_ctx.myTeamCount == 1 ? '' : 's'), 1),
                            (_ctx.mySummary.off)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _cache[40] || (_cache[40] = _createTextVNode(" · ", -1)),
                                  _createElementVNode("b", _hoisted_7, _toDisplayString(_ctx.mySummary.off) + " off", 1)
                                ], 64))
                              : _createCommentVNode("", true),
                            (_ctx.mySummary.missing)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _cache[41] || (_cache[41] = _createTextVNode(" · ", -1)),
                                  _createElementVNode("b", _hoisted_8, _toDisplayString(_ctx.mySummary.missing) + " to enter", 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ], 10, _hoisted_4))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamSummaries, (t) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: t.Name,
                        type: "button",
                        role: "tab",
                        "aria-selected": !_ctx.searching && !_ctx.activeTeam.Mine && t.Name == _ctx.activeTeam.Name,
                        class: _normalizeClass(["sb-team", !_ctx.searching && !_ctx.activeTeam.Mine && t.Name == _ctx.activeTeam.Name ? 'on' : '']),
                        onClick: ($event: any) => (_ctx.selectTeam(t.Name))
                      }, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.teamLabel(t.Name)), 1),
                        _createElementVNode("span", _hoisted_11, [
                          _createTextVNode(_toDisplayString(t.count) + " metric" + _toDisplayString(t.count == 1 ? '' : 's'), 1),
                          (t.off)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _cache[42] || (_cache[42] = _createTextVNode(" · ", -1)),
                                _createElementVNode("b", _hoisted_12, _toDisplayString(t.off) + " off", 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (t.missing)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _cache[43] || (_cache[43] = _createTextVNode(" · ", -1)),
                                _createElementVNode("b", _hoisted_13, _toDisplayString(t.missing) + " to enter", 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ], 10, _hoisted_9))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(_ctx.view == 'cards' ? 'on' : ''),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setView('cards')))
                  }, "Cards", 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(_ctx.view == 'grid' ? 'on' : ''),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setView('grid')))
                  }, "13 Weeks", 2)
                ]),
                (!_ctx.team)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _cache[45] || (_cache[45] = _createElementVNode("svg", {
                        viewBox: "0 0 24 24",
                        "aria-hidden": "true"
                      }, [
                        _createElementVNode("circle", {
                          cx: "11",
                          cy: "11",
                          r: "7"
                        }),
                        _createElementVNode("path", { d: "M21 21l-4.35-4.35" })
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.search) = $event)),
                        type: "text",
                        placeholder: "Search all metrics",
                        "aria-label": "Search all metrics",
                        onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.search = ''), ["esc"]))
                      }, null, 544), [
                        [_vModelText, _ctx.search]
                      ]),
                      (_ctx.searching)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.teamMetrics.length) + " found", 1))
                        : _createCommentVNode("", true),
                      (_ctx.search)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "sb-search-clear",
                            title: "Clear search",
                            "aria-label": "Clear search",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.search = ''))
                          }, [...(_cache[44] || (_cache[44] = [
                            _createElementVNode("svg", {
                              viewBox: "0 0 24 24",
                              "aria-hidden": "true"
                            }, [
                              _createElementVNode("path", { d: "M18 6L6 18M6 6l12 12" })
                            ], -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _cache[48] || (_cache[48] = _createElementVNode("span", { style: {"flex":"1"} }, null, -1)),
                _cache[49] || (_cache[49] = _createElementVNode("span", { class: "sb-muted sb-tagline" }, "One owner, one number, every week.", -1)),
                (_ctx.canAddMetrics && !_ctx.team && _ctx.canForge)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "ai-btn sb-btn sb-forge",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showForge = true))
                    }, [...(_cache[46] || (_cache[46] = [
                      _createElementVNode("svg", {
                        "aria-hidden": "true",
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "15",
                        height: "15",
                        viewBox: "0 0 24 24",
                        fill: "currentColor",
                        "fill-rule": "evenodd"
                      }, [
                        _createElementVNode("path", { d: "M12 23c-4.4 0-8-3.1-8-7.5 0-3.3 2-5.6 3.6-7.4.4-.4 1.1-.1 1.1.5 0 1.3.6 2.6 1.6 3.2C10.1 7.7 11.6 4 15 1.2c.4-.3 1 0 1 .5-.1 2.6.9 4.5 2.2 6.4C19.3 9.8 20 11.6 20 15.5 20 19.9 16.4 23 12 23zm0-2c1.9 0 3.3-1.3 3.3-3.1 0-1.6-.9-2.7-2.1-3.9-.3-.3-.8-.1-.8.3-.1 1-.6 1.8-1.3 2.2-.1-1.1-.5-2-1.1-2.6-.3-.3-.8-.1-.8.3-.3 1.3-1.5 2.2-1.5 3.7C7.7 19.7 9.8 21 12 21z" })
                      ], -1),
                      _createTextVNode("Improve with AI", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (!_ctx.activeTeam.Mine && !_ctx.searching)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (_ctx.$store.state.user.isAdmin)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "btn-light sb-btn",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showWhoCanView = true))
                          }, [...(_cache[47] || (_cache[47] = [
                            _createElementVNode("svg", {
                              viewBox: "0 0 24 24",
                              "aria-hidden": "true"
                            }, [
                              _createElementVNode("path", { d: "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" }),
                              _createElementVNode("circle", {
                                cx: "12",
                                cy: "12",
                                r: "3"
                              })
                            ], -1),
                            _createTextVNode("Who Can View", -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      (_ctx.canAddMetrics)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "btn-light sb-btn",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openMetric(null)))
                          }, "Add Metric"))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createTextVNode(_toDisplayString(_ctx.searching ? 'Search results' : _ctx.teamLabel(_ctx.activeTeam.Name)) + " · " + _toDisplayString(_ctx.weekAgoText) + " · Wk " + _toDisplayString(_ctx.weekNumber(_ctx.currentWeek)), 1),
                    (!_ctx.isDueWeek)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "sb-week-today",
                          onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.goToWeek(_ctx.dueWeek)), ["prevent"]))
                        }, "Back to " + _toDisplayString(_ctx.dueWeek == _ctx.thisWeek ? 'This Week' : 'Last Week'), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "sb-week-arrow",
                      title: "Previous week",
                      "aria-label": "Previous week",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goToWeek(_ctx.addDays(_ctx.currentWeek, -7))))
                    }, "‹"),
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.weekRange(_ctx.currentWeek)), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "sb-week-arrow",
                      title: "Next week",
                      "aria-label": "Next week",
                      disabled: _ctx.currentWeek >= _ctx.thisWeek,
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.goToWeek(_ctx.addDays(_ctx.currentWeek, 7))))
                    }, "›", 8, _hoisted_23)
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.enteredCount), 1),
                  _createTextVNode("/" + _toDisplayString(_ctx.teamMetrics.length), 1),
                  _cache[50] || (_cache[50] = _createElementVNode("span", null, "entered", -1))
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["sb-stat", _ctx.offCount ? 'bad' : ''])
                }, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.offCount), 1),
                  _cache[51] || (_cache[51] = _createElementVNode("span", null, "off goal", -1))
                ], 2),
                _createElementVNode("div", _hoisted_25, [
                  (!_ctx.teamMetrics.length && _ctx.searching)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("No metrics match your search.")
                      ], 64))
                    : (!_ctx.teamMetrics.length && _ctx.activeTeam.Mine)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("You don't own any metrics yet.")
                        ], 64))
                      : (!_ctx.teamMetrics.length)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode("No metrics yet. Most teams track 5 to 15 weekly numbers.")
                          ], 64))
                        : (_ctx.activeTeam.Mine || _ctx.searching || !_ctx.isDueWeek)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createTextVNode(_toDisplayString(_ctx.missingMetrics.length ? _ctx.missingMetrics.length + (_ctx.isDueWeek ? ' still to enter.' : ' not entered for this week.') : 'All numbers are in.'), 1)
                            ], 64))
                          : (_ctx.missingMetrics.length)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                _createTextVNode(_toDisplayString(_ctx.missingMetrics.length) + " still to enter, due " + _toDisplayString(_ctx.dueText(_ctx.activeTeam.DueDay, _ctx.activeTeam.DueTime)) + ". ", 1),
                                (_ctx.waitingOn.length)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode("Waiting on " + _toDisplayString(_ctx.waitingOn.join(', ')) + ".", 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                _createTextVNode("All numbers are in. Due " + _toDisplayString(_ctx.dueText(_ctx.activeTeam.DueDay, _ctx.activeTeam.DueTime)) + ".", 1)
                              ], 64))
                ]),
                (_ctx.isDueWeek && _ctx.waitingOnOthers.length && !_ctx.searching)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["btn-light sb-btn", _ctx.nudged[_ctx.activeTeam.Name] ? 'disable-button' : '']),
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showNudge = true))
                    }, _toDisplayString(_ctx.nudged[_ctx.activeTeam.Name] ? 'Reminded' : 'Nudge ' + _ctx.waitingOnOthers.length), 3))
                  : _createCommentVNode("", true),
                (_ctx.teamMetrics.length)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "btn sb-btn",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => {_ctx.entryMetric = null; _ctx.showEntry = true})
                    }, "Enter Numbers"))
                  : _createCommentVNode("", true),
                (!_ctx.activeTeam.Mine && !_ctx.searching)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "button",
                      class: "sb-due-btn",
                      title: "When this team's numbers are due",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.openDue()))
                    }, [
                      _createVNode(_component_svg_icon, { icon: "gear" })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (!_ctx.teamMetrics.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createVNode(_component_svg_icon, { icon: "chart" }),
                    (_ctx.searching)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", null, "No metrics match \"" + _toDisplayString(_ctx.search.trim()) + "\".", 1),
                          _createElementVNode("div", {
                            class: "btn-light sb-btn",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.search = ''))
                          }, "Clear Search")
                        ], 64))
                      : (_ctx.activeTeam.Mine)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, "You don't own any metrics yet. Metrics you're the owner of, on any team, show up here."))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.teamLabel(_ctx.activeTeam.Name)) + " doesn't have any metrics yet.", 1),
                            (_ctx.canAddMetrics)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "btn sb-btn",
                                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.openMetric(null)))
                                }, "Add the First Metric"))
                              : _createCommentVNode("", true)
                          ], 64))
                  ]))
                : (_ctx.view == 'cards')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metricGroups, (g) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: g.team || 'team'
                        }, [
                          (g.team)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createTextVNode(_toDisplayString(_ctx.teamLabel(g.team)), 1),
                                _createElementVNode("span", null, _toDisplayString(g.metrics.length), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.metrics, (m) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: m.ID,
                              class: _normalizeClass(["sb-card", _ctx.cardState(m).cls])
                            }, [
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("div", _hoisted_31, [
                                  _createVNode(_component_svg_icon, {
                                    icon: _ctx.metricIcon(m)
                                  }, null, 8, ["icon"])
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["sb-mname sb-card-title", _ctx.canAddMetrics && m.CanEdit ? '' : 'sb-mname-static']),
                                    onClick: ($event: any) => (_ctx.openMetric(m))
                                  }, _toDisplayString(m.Name), 11, _hoisted_33),
                                  _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.activeTeam.Mine && !_ctx.searching ? 'Due ' + _ctx.dueText(m.DueDay, m.DueTime) : _ctx.ownerName(m)), 1)
                                ]),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["sb-pill", _ctx.cardState(m).cls])
                                }, _toDisplayString(_ctx.cardState(m).label), 3)
                              ]),
                              (_ctx.offStreak(m, _ctx.weeks) >= 3)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                    _createVNode(_component_svg_icon, { icon: "alerttriangle" }),
                                    _createTextVNode("Off goal " + _toDisplayString(_ctx.offStreak(m, _ctx.weeks)) + " weeks in a row", 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.relativeWeekLabel(_ctx.currentWeek)), 1),
                                  _createElementVNode("b", {
                                    class: _normalizeClass(_ctx.statClass(m))
                                  }, _toDisplayString(_ctx.hasValue(m, _ctx.currentWeek) ? _ctx.formatShort(m, m.Values[_ctx.currentWeek]) : '—'), 3)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[52] || (_cache[52] = _createElementVNode("span", null, "Goal", -1)),
                                  _createElementVNode("b", null, _toDisplayString(_ctx.goalText(m, _ctx.currentWeek, true)), 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[53] || (_cache[53] = _createElementVNode("span", null, "4-wk avg", -1)),
                                  _createElementVNode("b", null, _toDisplayString(_ctx.fourWeekAvg(m) === null ? '—' : _ctx.formatShort(m, _ctx.fourWeekAvg(m))), 1)
                                ])
                              ]),
                              (m.Definition)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(m.Definition), 1))
                                : (_ctx.canAddMetrics && m.CanEdit)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      type: "button",
                                      class: "sb-def sb-def-none",
                                      onClick: ($event: any) => (_ctx.openMetric(m))
                                    }, "No definition. Add how it's counted.", 8, _hoisted_38))
                                  : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["sb-prog", _ctx.passes(m, m.Values[_ctx.currentWeek], _ctx.currentWeek) ? 'ok' : ''])
                                }, [
                                  _createElementVNode("span", {
                                    style: _normalizeStyle('width:' + _ctx.progress(m, m.Values[_ctx.currentWeek], _ctx.currentWeek) + '%')
                                  }, null, 4)
                                ], 2),
                                (_ctx.trend(m))
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass(["sb-trend", _ctx.trend(m).cls])
                                    }, _toDisplayString(_ctx.trend(m).text), 3))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "sb-card-b sb-card-b-main",
                                  onClick: ($event: any) => {_ctx.entryMetric = m; _ctx.showEntry = true}
                                }, _toDisplayString(_ctx.hasValue(m, _ctx.currentWeek) ? 'Update' : 'Enter Week'), 9, _hoisted_41),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "sb-card-b",
                                  onClick: ($event: any) => (_ctx.trendMetric = m)
                                }, "Trend", 8, _hoisted_42),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "sb-card-b sb-card-b-issue",
                                  onClick: ($event: any) => (_ctx.openIssue(m))
                                }, "Issue", 8, _hoisted_43)
                              ])
                            ], 2))
                          }), 128))
                        ], 64))
                      }), 128)),
                      (!_ctx.activeTeam.Mine && !_ctx.searching && _ctx.canAddMetrics)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "sb-card-add",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.openMetric(null)))
                          }, [
                            _createVNode(_component_svg_icon, { icon: "plus" }),
                            _createTextVNode("Add Metric to " + _toDisplayString(_ctx.teamLabel(_ctx.activeTeam.Name)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("table", _hoisted_45, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _cache[54] || (_cache[54] = _createElementVNode("th", { class: "sb-o" }, "Who", -1)),
                              _cache[55] || (_cache[55] = _createElementVNode("th", { class: "sb-m" }, "Metric", -1)),
                              _cache[56] || (_cache[56] = _createElementVNode("th", { class: "sb-g" }, "Goal", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weeks, (w, i) => {
                                return (_openBlock(), _createElementBlock("th", {
                                  key: w,
                                  class: _normalizeClass(i == _ctx.weeks.length - 1 ? 'now' : ''),
                                  title: 'Week of ' + _ctx.weekRange(w)
                                }, _toDisplayString(_ctx.weekLabel(w)), 11, _hoisted_46))
                              }), 128)),
                              _cache[57] || (_cache[57] = _createElementVNode("th", { class: "sb-avg" }, "13-wk avg", -1))
                            ])
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metricGroups, (g) => {
                            return (_openBlock(), _createElementBlock("tbody", {
                              key: g.team || 'team'
                            }, [
                              (g.team)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_47, [
                                    _createElementVNode("td", {
                                      colspan: _ctx.weeks.length + 4
                                    }, [
                                      _createElementVNode("span", _hoisted_49, [
                                        _createTextVNode(_toDisplayString(_ctx.teamLabel(g.team)), 1),
                                        _createElementVNode("span", null, _toDisplayString(g.metrics.length), 1)
                                      ])
                                    ], 8, _hoisted_48)
                                  ]))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.metrics, (m) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: m.ID
                                }, [
                                  _createElementVNode("td", _hoisted_50, [
                                    _createElementVNode("span", {
                                      class: "sb-own",
                                      title: _ctx.ownerName(m)
                                    }, _toDisplayString(_ctx.initials(_ctx.ownerName(m))), 9, _hoisted_51)
                                  ]),
                                  _createElementVNode("td", _hoisted_52, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: _normalizeClass(["sb-mname", _ctx.canAddMetrics && m.CanEdit ? '' : 'sb-mname-static']),
                                      title: m.Definition,
                                      onClick: ($event: any) => (_ctx.openMetric(m))
                                    }, _toDisplayString(m.Name), 11, _hoisted_53),
                                    (_ctx.offStreak(m, _ctx.weeks) >= 3)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "sb-sk",
                                          title: 'Off goal ' + _ctx.offStreak(m, _ctx.weeks) + ' weeks in a row'
                                        }, [
                                          _createVNode(_component_svg_icon, { icon: "alerttriangle" }),
                                          _createTextVNode(_toDisplayString(_ctx.offStreak(m, _ctx.weeks)), 1)
                                        ], 8, _hoisted_54))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("td", _hoisted_55, [
                                    _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.goalText(m, _ctx.currentWeek, true)), 1)
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weeks, (w, i) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: w }, [
                                      (_ctx.editCell && _ctx.editCell.metricID == m.ID && _ctx.editCell.week == w)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_57, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "number",
                                              step: "any",
                                              class: "sb-cellin",
                                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.editCell.value) = $event)),
                                              ref_for: true,
                                              ref: "cellInput",
                                              "aria-label": m.Name + ', week of ' + _ctx.weekLabel(w),
                                              onKeyup: [
                                                _cache[19] || (_cache[19] = _withKeys(($event: any) => (_ctx.saveCell()), ["enter"])),
                                                _cache[20] || (_cache[20] = _withKeys(($event: any) => (_ctx.editCell = null), ["esc"]))
                                              ],
                                              onBlur: _cache[21] || (_cache[21] = ($event: any) => (_ctx.saveCell()))
                                            }, null, 40, _hoisted_58), [
                                              [_vModelText, _ctx.editCell.value]
                                            ])
                                          ]))
                                        : (_openBlock(), _createElementBlock("td", {
                                            key: 1,
                                            class: _normalizeClass(["sb-c", _ctx.cellClass(m, w, i)]),
                                            title: 'Week of ' + _ctx.weekRange(w) + ' · goal ' + _ctx.goalText(m, w) + (_ctx.goalChangedAt(m, w) ? ' (goal changed this week)' : ''),
                                            onClick: ($event: any) => (_ctx.startCell(m, w))
                                          }, [
                                            (_ctx.hasValue(m, w))
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(_toDisplayString(_ctx.formatShort(m, m.Values[w])), 1)
                                                ], 64))
                                              : (i == _ctx.weeks.length - 1)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_60, "enter"))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                    _createTextVNode("—")
                                                  ], 64))
                                          ], 10, _hoisted_59))
                                    ], 64))
                                  }), 128)),
                                  _createElementVNode("td", _hoisted_61, _toDisplayString(_ctx.average(m, _ctx.weeks) === null ? '—' : _ctx.formatShort(m, _ctx.average(m, _ctx.weeks))), 1)
                                ]))
                              }), 128))
                            ]))
                          }), 128))
                        ])
                      ]),
                      _cache[58] || (_cache[58] = _createStaticVNode("<div class=\"sb-legend\" data-v-52b12fec><span data-v-52b12fec><i class=\"pass\" data-v-52b12fec></i>On goal</span><span data-v-52b12fec><i class=\"fail\" data-v-52b12fec></i>Off goal</span><span data-v-52b12fec><i data-v-52b12fec></i>Not entered</span><span data-v-52b12fec><i class=\"gchg\" data-v-52b12fec></i>Goal changed</span><span class=\"sb-muted\" data-v-52b12fec>Each week is colored against the goal that was set that week.</span></div>", 1))
                    ], 64))
            ], 64))
          : _createCommentVNode("", true),
    (_ctx.showMetric)
      ? (_openBlock(), _createBlock(_component_scoreboard_metric_modal, {
          key: 3,
          metric: _ctx.metricToEdit,
          team: _ctx.activeTeam.Name,
          teams: _ctx.teams.map(t => t.Name),
          employees: _ctx.employees,
          week: _ctx.thisWeek,
          onClose: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showMetric = false)),
          onSaved: _ctx.onMetricSaved
        }, null, 8, ["metric", "team", "teams", "employees", "week", "onSaved"]))
      : _createCommentVNode("", true),
    (_ctx.showEntry)
      ? (_openBlock(), _createBlock(_component_scoreboard_entry_modal, {
          key: 4,
          metrics: _ctx.teamMetrics,
          team: _ctx.searching ? '' : _ctx.activeTeam.Name,
          metric: _ctx.entryMetric,
          week: _ctx.currentWeek,
          employees: _ctx.employees,
          myEmployeeID: _ctx.myEmployeeID,
          onClose: _cache[23] || (_cache[23] = ($event: any) => (_ctx.closeEntry())),
          onSaved: _ctx.onEntrySaved
        }, null, 8, ["metrics", "team", "metric", "week", "employees", "myEmployeeID", "onSaved"]))
      : _createCommentVNode("", true),
    (_ctx.showNudge)
      ? (_openBlock(), _createBlock(_component_scoreboard_nudge_modal, {
          key: 5,
          team: _ctx.activeTeam.Name,
          week: _ctx.currentWeek,
          onClose: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showNudge = false)),
          onSent: _ctx.onNudgeSent
        }, null, 8, ["team", "week", "onSent"]))
      : _createCommentVNode("", true),
    (_ctx.showForge)
      ? (_openBlock(), _createBlock(_component_forge_team, {
          key: 6,
          modal: "",
          only: [ 'improvemetrics', 'scorecard' ],
          "start-kind": _ctx.teamMetrics.length ? 'improvemetrics' : 'scorecard',
          "preset-team": _ctx.activeTeam && !_ctx.activeTeam.Mine ? _ctx.activeTeam.Name : '',
          onApplied: _cache[25] || (_cache[25] = ($event: any) => (_ctx.load())),
          onClose: _cache[26] || (_cache[26] = ($event: any) => (_ctx.showForge = false))
        }, null, 8, ["start-kind", "preset-team"]))
      : _createCommentVNode("", true),
    (_ctx.showWhoCanView)
      ? (_openBlock(), _createBlock(_component_scoreboard_who_can_view, {
          key: 7,
          team: _ctx.activeTeam.Name,
          onClose: _cache[27] || (_cache[27] = ($event: any) => (_ctx.showWhoCanView = false))
        }, null, 8, ["team"]))
      : _createCommentVNode("", true),
    (_ctx.trendMetric)
      ? (_openBlock(), _createBlock(_component_scoreboard_trend_modal, {
          key: 8,
          metric: _ctx.trendMetric,
          weeks: _ctx.weeks,
          "owner-name": _ctx.ownerName(_ctx.trendMetric),
          onClose: _cache[28] || (_cache[28] = ($event: any) => (_ctx.trendMetric = null)),
          onEnter: _cache[29] || (_cache[29] = ($event: any) => (_ctx.enterFromTrend()))
        }, null, 8, ["metric", "weeks", "owner-name"]))
      : _createCommentVNode("", true),
    (_ctx.issue)
      ? (_openBlock(), _createBlock(_component_quick_add_agenda_item, {
          key: 9,
          heading: "Add Issue",
          "prefer-column": "Issues",
          preset: _ctx.issue.preset,
          team: _ctx.issue.team,
          "fixed-meeting": _ctx.meeting,
          onClose: _cache[30] || (_cache[30] = ($event: any) => (_ctx.issue = null))
        }, null, 8, ["preset", "team", "fixed-meeting"]))
      : _createCommentVNode("", true),
    (_ctx.dueForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("button", {
                type: "button",
                class: "form-close-x",
                title: "Close",
                onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.dueForm = null))
              }, "×")
            ]),
            _createElementVNode("h2", _hoisted_65, "When " + _toDisplayString(_ctx.teamLabel(_ctx.activeTeam.Name)) + " numbers are due", 1),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("div", null, [
                _cache[59] || (_cache[59] = _createElementVNode("div", { class: "sb-label" }, "Day", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.dueForm.DueDay) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DAY_NAMES, (d, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: i
                    }, _toDisplayString(d), 9, _hoisted_67))
                  }), 128))
                ], 512), [
                  [
                    _vModelSelect,
                    _ctx.dueForm.DueDay,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[60] || (_cache[60] = _createElementVNode("div", { class: "sb-label" }, "Time", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "time",
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.dueForm.DueTime) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.dueForm.DueTime]
                ])
              ])
            ]),
            _cache[62] || (_cache[62] = _createElementVNode("div", {
              class: "sb-label",
              style: {"margin-top":"14px"}
            }, "Numbers are for", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.dueForm.ReportWeek) = $event))
            }, [...(_cache[61] || (_cache[61] = [
              _createElementVNode("option", { value: "last" }, "The week just finished", -1),
              _createElementVNode("option", { value: "current" }, "The current week", -1)
            ]))], 512), [
              [_vModelSelect, _ctx.dueForm.ReportWeek]
            ]),
            _createElementVNode("p", _hoisted_68, "Due " + _toDisplayString(_ctx.dueText(_ctx.dueForm.DueDay, _ctx.dueForm.DueTime)) + " for " + _toDisplayString(_ctx.dueForm.ReportWeek == 'current' ? 'that same week' : 'the week before') + ".", 1),
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", {
                class: "btn-light",
                onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.dueForm = null))
              }, "Cancel"),
              _createElementVNode("div", {
                class: "btn",
                onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.saveDue()))
              }, "Save")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}